<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <div class="dialog-container">
    <!-- AI防災リスク診断 モード選択 -->
    <v-dialog v-model="vm.showAreaAnalysisModeDialog" max-width="600">
      <v-card>
        <v-card-title class="text-h5 d-flex align-center">
          <v-icon class="mr-2" size="32" color="primary">mdi-shield-alert</v-icon>
          <span class="font-weight-bold text-primary">AI防災リスク診断</span>
        </v-card-title>
        <v-card-text class="text-body-2">
          範囲の指定方法を選んでください
        </v-card-text>
        <v-card-actions class="flex-wrap justify-end ga-2">
          <v-btn variant="text" color="grey" @click="vm.cancelAreaAnalysisModeDialog">
            <v-icon size="small" class="mr-1">mdi-close</v-icon>
            キャンセル
          </v-btn>
          <v-btn color="primary" variant="elevated" @click="vm.selectAreaAnalysisMode('point')">
            <v-icon size="small" class="mr-1">mdi-map-marker</v-icon>
            ポイント
          </v-btn>
          <v-btn variant="outlined" color="primary" @click="vm.selectAreaAnalysisMode('freehand')">
            <v-icon size="small" class="mr-1">mdi-gesture</v-icon>
            フリーハンド
          </v-btn>
          <v-btn variant="outlined" color="primary" @click="vm.selectAreaAnalysisMode('circle')">
            <v-icon size="small" class="mr-1">mdi-circle-outline</v-icon>
            サークル
          </v-btn>
          <v-btn variant="outlined" color="primary" @click="vm.selectAreaAnalysisMode('polygon')">
            <v-icon size="small" class="mr-1">mdi-vector-polygon</v-icon>
            ポリゴン
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 断面図 モード選択 -->
    <v-dialog v-model="vm.showElevationProfileModeDialog" max-width="400">
      <v-card>
        <v-card-title class="text-h5 d-flex align-center">
          <v-icon class="mr-2" size="32" color="primary">mdi-chart-line-variant</v-icon>
          <span class="font-weight-bold" style="color: var(--oh3-color-primary);">断面図</span>
        </v-card-title>
        <v-card-text>
          <div class="text-body-2">描画方法を選んでください</div>
        </v-card-text>
        <v-card-actions class="justify-end ga-2">
          <v-btn variant="text" color="grey" @click="vm.showElevationProfileModeDialog = false">
            <v-icon size="small" class="mr-1">mdi-close</v-icon>キャンセル
          </v-btn>
          <v-btn color="primary" variant="elevated" @click="vm.selectElevationProfileMode('line')">
            <v-icon size="small" class="mr-1">mdi-vector-line</v-icon>ライン
          </v-btn>
          <v-btn variant="outlined" color="primary" @click="vm.selectElevationProfileMode('free')">
            <v-icon size="small" class="mr-1">mdi-gesture</v-icon>フリーハンド
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- フリーハンド断面図不可の案内 -->
    <v-dialog v-model="vm.showFreehandInfoDialog" max-width="400">
      <v-card>
        <v-card-title class="text-h6 d-flex align-center">
          <v-icon class="mr-2" color="info">mdi-information</v-icon>
          フリーハンドモード
        </v-card-title>
        <v-card-text>
          フリーハンドでは断面図は作成できません。<br>
          標高図と<strong>3Dジオラマ</strong>で表示します。
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn color="primary" variant="elevated" @click="vm.confirmFreehandDraw">
            <v-icon size="small" class="mr-1">mdi-gesture</v-icon>OK・描画開始
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- AI人口プロファイル モード選択 -->
    <v-dialog v-model="vm.showPopulationProfileModeDialog" max-width="600">
      <v-card>
        <v-card-title class="text-h5 d-flex align-center">
          <v-icon class="mr-2" size="32" color="purple">mdi-account-group</v-icon>
          <span class="font-weight-bold" style="color: #7B1FA2;">AI人口プロファイル</span>
        </v-card-title>
        <v-card-text>
          <div class="text-body-2 mb-3">
            分析方法を選んでください
          </div>
          <v-alert type="info" variant="tonal" density="compact" class="mb-0">
            <div class="text-caption">
              <strong>📍 小地域モード</strong>：小地域データを使用。4時期の人口ピラミッドと推移グラフが表示できます。<br>
              <strong>🖊️ エリアモード</strong>（フリーハンド・サークル・ポリゴン）：125mメッシュデータを使用。選択範囲内の人口を集計します。<br>
              <span class="text-grey">※エリアモードでもピラミッド・推移グラフを表示可（狭い範囲のみ）</span>
            </div>
          </v-alert>
        </v-card-text>
        <v-card-actions class="flex-wrap justify-end ga-2">
          <v-btn variant="text" color="grey" @click="vm.cancelPopulationProfileModeDialog">
            <v-icon size="small" class="mr-1">mdi-close</v-icon>
            キャンセル
          </v-btn>
          <v-btn color="purple" variant="elevated" @click="vm.selectPopulationProfileMode('point')">
            <v-icon size="small" class="mr-1">mdi-map-marker</v-icon>
            小地域
          </v-btn>
          <v-btn variant="outlined" color="purple" @click="vm.selectPopulationProfileMode('freehand')">
            <v-icon size="small" class="mr-1">mdi-gesture</v-icon>
            フリーハンド
          </v-btn>
          <v-btn variant="outlined" color="purple" @click="vm.selectPopulationProfileMode('circle')">
            <v-icon size="small" class="mr-1">mdi-circle-outline</v-icon>
            サークル
          </v-btn>
          <v-btn variant="outlined" color="purple" @click="vm.selectPopulationProfileMode('polygon')">
            <v-icon size="small" class="mr-1">mdi-vector-polygon</v-icon>
            ポリゴン
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 土地法規等調査 モード選択 -->
    <v-dialog v-model="vm.showFsInvestigationModeDialog" max-width="600">
      <v-card>
        <v-card-title class="text-h5 d-flex align-center">
          <v-icon class="mr-2" size="32" color="blue-darken-3">mdi-scale-balance</v-icon>
          <span class="font-weight-bold" style="color: #1565C0;">土地法規等調査</span>
        </v-card-title>
        <v-card-text>
          <div class="text-body-2 mb-3">
            調査方法を選んでください
          </div>
          <v-alert type="info" variant="tonal" density="compact" class="mb-0">
            <div class="text-caption">
              <strong>📍 ポイントモード</strong>：地点をクリックして、その地点の法規制を調査します。<br>
              <strong>🖊️ エリアモード</strong>（フリーハンド・サークル・ポリゴン）：囲んだ範囲と少しでも重なる法規制を一括調査します。<br>
              <span class="text-grey">※エリアモードは40ha以内に限定されます</span>
            </div>
          </v-alert>
        </v-card-text>
        <v-card-actions class="flex-wrap justify-end ga-2">
          <v-btn variant="text" color="grey" @click="vm.cancelFsInvestigationModeDialog">
            <v-icon size="small" class="mr-1">mdi-close</v-icon>
            キャンセル
          </v-btn>
          <v-btn variant="outlined" color="blue-darken-3" @click="vm.selectFsInvestigationMode('point')">
            <v-icon size="small" class="mr-1">mdi-map-marker</v-icon>
            ポイント
          </v-btn>
          <v-btn variant="outlined" color="blue-darken-3" @click="vm.selectFsInvestigationMode('freehand')">
            <v-icon size="small" class="mr-1">mdi-gesture</v-icon>
            フリーハンド
          </v-btn>
          <v-btn variant="outlined" color="blue-darken-3" @click="vm.selectFsInvestigationMode('circle')">
            <v-icon size="small" class="mr-1">mdi-circle-outline</v-icon>
            サークル
          </v-btn>
          <v-btn variant="outlined" color="blue-darken-3" @click="vm.selectFsInvestigationMode('polygon')">
            <v-icon size="small" class="mr-1">mdi-vector-polygon</v-icon>
            ポリゴン
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 土地法規等調査 面積超過エラーダイアログ -->
    <v-dialog v-model="vm.showFsAreaTooLargeDialog" max-width="450">
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon class="mr-2" color="warning">mdi-alert-circle</v-icon>
          範囲が大きすぎます
        </v-card-title>
        <v-card-text>
          <div class="mb-3">
            土地法規等調査のフリーハンドモードは40ha以内に制限されています。
          </div>
          <div class="mb-2">
            <strong>最大範囲:</strong> 40ha
          </div>
          <div class="mb-3">
            <strong>選択した範囲:</strong> {{ vm.fsAreaTooLargeValue }}ha
          </div>
          <div class="text-body-2 text-grey-darken-1">
            より小さい範囲を選択してください。
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="vm.showFsAreaTooLargeDialog = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 共有地物アクションダイアログ（3択） -->
    <v-dialog v-model="vm.showShareFeatureActionDialog" max-width="400">
      <v-card v-if="vm.shareFeatureActionProps">
        <v-card-title class="d-flex align-center">
          <v-icon class="mr-2" :color="vm.shareFeatureActionProps.aiType === 'risk' ? 'error' : 'primary'">mdi-map-marker-question</v-icon>
          {{ vm.shareFeatureActionProps.typeName }}
        </v-card-title>
        <v-card-text>
          この{{ vm.shareFeatureActionProps.isPolygon ? '地域' : '地点' }}の{{ vm.shareFeatureActionProps.typeName }}をどうしますか？
        </v-card-text>
        <v-card-actions class="justify-end flex-wrap ga-2 pb-4 px-4">
          <v-btn variant="text" color="grey" @click="vm.resolveShareFeatureAction('cancel')">
            キャンセル
          </v-btn>
          <v-btn variant="outlined" color="error" @click="vm.resolveShareFeatureAction('delete')">
            <v-icon size="small" class="mr-1">mdi-delete</v-icon>
            地物を削除
          </v-btn>
          <v-btn variant="elevated" color="primary" @click="vm.resolveShareFeatureAction('open')">
            <v-icon size="small" class="mr-1">mdi-open-in-new</v-icon>
            レポートを開く
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 面積超過エラーダイアログ -->
    <v-dialog v-model="vm.showAreaTooLargeDialog" max-width="450">
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon class="mr-2" color="warning">mdi-alert-circle</v-icon>
          範囲が大きすぎます
        </v-card-title>
        <v-card-text>
          <div class="mb-3">
            AI防災リスク診断は町丁目レベルの詳細分析に特化しています。
          </div>
          <div class="mb-2">
            <strong>最大範囲:</strong> 80万m²
          </div>
          <div class="mb-3">
            <strong>選択した範囲:</strong> {{ vm.areaTooLargeValue }}万m²
          </div>
          <div class="text-body-2 text-grey-darken-1">
            より小さい範囲を選択してください。<br>
            町丁目・自治会レベルの範囲がおすすめです。
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="vm.showAreaTooLargeDialog = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 確認ダイアログ（ログクリア） -->
    <v-dialog v-model="vm.confirmClearLog" max-width="500">
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon color="warning" class="mr-2">mdi-alert-circle-outline</v-icon>
          ログをクリアしますか？
        </v-card-title>
        <v-card-text>
          これまで記録した座標ログ（{{ (vm.csvRows?.length || 1) - 1 }} 件）が削除されます。
          {{ vm.logEnabled ? '現在の記録は停止されます。' : '' }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="vm.confirmClearLog = false">キャンセル</v-btn>
          <v-btn color="red" variant="elevated" @click="vm.doClearLog">クリア</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 投げ縄クローズ確認ダイアログ -->
    <v-dialog v-model="vm.showLassoCloseConfirm" max-width="340px">
      <v-card>
        <v-card-title class="text-subtitle-1">
          <v-icon color="warning" class="mr-2">mdi-alert</v-icon>
          変更を破棄しますか？
        </v-card-title>
        <v-card-text>
          このまま閉じると、移動・回転・拡大縮小・色変更などの変更がすべて元に戻ります。
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn variant="text" @click="vm.showLassoCloseConfirm = false">キャンセル</v-btn>
          <v-btn color="warning" variant="tonal" @click="vm.confirmLassoClose">元に戻して閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 登記簿PDF一括処理ダイアログ -->
    <v-dialog v-model="vm.toukiBatchDialog" persistent max-width="400">
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon color="indigo" class="mr-2">mdi-file-pdf-box</v-icon>
          登記簿PDF解析中
        </v-card-title>
        <v-card-text>
          <div class="text-center mb-4">
            <v-progress-circular
              indeterminate
              color="indigo"
              size="64"
            ></v-progress-circular>
          </div>
          <div class="text-center text-h6 mb-2">
            {{ vm.toukiBatchProgress.current }} / {{ vm.toukiBatchProgress.total }}
          </div>
          <div class="text-center text-caption text-medium-emphasis" style="word-break: break-all;">
            {{ vm.toukiBatchProgress.fileName }}
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- 画像・動画アップロード -->
    <v-dialog class="exclude-overlay" v-model="vm.s_dialogForPicture" max-width="500" :style="{zIndex: vm.dialogForPictureZindex}">
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-image-plus</v-icon>
          写真・PDFアップロード
        </v-card-title>
        <v-card-text style="padding-bottom: 0; padding-top: var(--oh3-spacing-4)">

            <div class="media-picker-row">
              <!-- iPhone のとき：カメラ(アイコン) + ライブラリ選択 を横並び -->
              <template v-if="vm.isIphone">
                <!-- ネイティブ input は非表示。ボタンで click() を発火 -->
                <input
                    id="iosCamInput"
                    type="file"
                    accept="image/*"
                    capture="environment"
                    class="sr-only"
                    @change="vm.onCameraPicked"
                />
                <v-btn
                    icon
                    class="camera-btn"
                    @click="vm.triggerCamera"
                    :ripple="false"
                    aria-label="カメラで撮影"
                >
                  <v-icon>mdi-camera</v-icon>
                </v-btn>
                <v-file-input
                    v-model="vm.s_selectedFile"
                    accept="image/*,video/*,.pdf"
                    :multiple="false"
                    density="comfortable"
                    variant="solo-filled"
                    hide-details
                    :show-size="true"
                    prepend-inner-icon="mdi-image-multiple"
                    label="フォトライブラリから選択"
                    @update:model-value="vm.onFileSelected"
                    class="library-input"
                />
              </template>
              <!-- それ以外（iPhone以外）：通常の v-file-input のみ -->
              <template v-else>
                <v-file-input
                    v-model="vm.s_selectedFile"
                    label="写真・PDFを選択"
                    accept="image/*,video/*,.pdf"
                    :multiple="false"
                    density="comfortable"
                    variant="solo-filled"
                    hide-details
                    :show-size="true"
                    prepend-inner-icon="mdi-file-image"
                    @update:model-value="vm.onFileSelected"
                    class="w-full"
                />
              </template>
            </div>

            <div style="max-height: 300px; margin-bottom: var(--oh3-spacing-3); overflow: auto">
              <div v-if="vm.s_previewUrl" class="mt-4 text-center" style="margin-bottom: 10px;">
                <img
                    v-if="vm.isImage"
                    :src="vm.s_previewUrl"
                    alt="プレビュー"
                    style="max-width: 100%; transition: transform 0.3s;"
                    :style="{ transform: 'rotate(' + vm.imgRotation + 'deg)' }"
                />
                <video v-if="vm.isVideo" controls style="max-width: 100%;">
                  <source :src="vm.s_previewUrl" type="video/mp4" />
                  お使いのブラウザは video タグに対応していません。
                </video>
                <div v-if="vm.isPdf" class="mt-4 text-center">
                  <v-icon size="64" color="red">mdi-file-pdf-box</v-icon>
                  <div style="font-size: var(--oh3-font-size-3); margin-top: var(--oh3-spacing-2);">
                    {{ vm.s_selectedFileName || 'PDF' }}
                  </div>
                </div>
              </div>
            </div>

            <v-row v-if="vm.isImage || vm.isVideo" align="center" dense class="mx-0 mb-1">
              <v-col cols="6" class="px-1">
                <template v-if="vm.s_isAndroid">
                  <div class="native-select-wrapper">
                    <label class="native-select-label" for="thumbnail-select">サムネイルを選択</label>
                    <select id="thumbnail-select" v-model="vm.thumbnailType" class="native-select" @change="vm.isDisabledChange">
                      <option v-for="item in vm.thumbnailTypes" :key="item.value" :value="item.value">
                        {{ item.label }}
                      </option>
                    </select>
                  </div>
                </template>
                <v-select v-else
                          v-model="vm.thumbnailType"
                          :items="vm.thumbnailTypes"
                          item-title="label"
                          item-value="value"
                          label="サムネイルを選択"
                          variant="outlined"
                          density="comfortable"
                          hide-details
                          @update:modelValue="vm.isDisabledChange"
                          :menu-props="{
                            maxHeight: '300px',
                            overflow: 'scroll',
                            contentClass: 'scrollable-menu'
                          }"
                ></v-select>
              </v-col>
              <v-col cols="6" class="px-1">
                <template v-if="vm.s_isAndroid">
                  <div class="native-select-wrapper">
                    <label class="native-select-label" for="container-color-select">縁の色を選択</label>
                    <select id="container-color-select" v-model="vm.containerColor" class="native-select" @change="vm.isDisabledChange">
                      <option v-for="item in vm.containerColors" :key="item.value" :value="item.value">
                        {{ item.label }}
                      </option>
                    </select>
                  </div>
                </template>
                <v-select v-else
                          v-model="vm.containerColor"
                          :items="vm.containerColors"
                          item-title="label"
                          item-value="value"
                          label="縁の色を選択"
                          variant="outlined"
                          density="comfortable"
                          hide-details
                          @update:modelValue="vm.isDisabledChange"
                          :menu-props="{
                            maxHeight: '300px',
                            overflow: 'scroll',
                            contentClass: 'scrollable-menu'
                          }"
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-if="vm.isImage" align="center" dense class="mx-0 mt-0 mb-1">
              <v-col cols="12" class="px-1 d-flex align-center py-0">
                <MiniTooltip text="画像を回転します" :offset-x="0" :offset-y="2">
                  <v-btn
                      icon
                      variant="outlined"
                      @click="vm.imgRotation += -90; vm.isDisabled2 = false"
                      class="me-2"
                  >
                    <v-icon>mdi-rotate-left</v-icon>
                  </v-btn>
                </MiniTooltip>
                <span class="text-body-2">画像を回転</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
                <v-btn
                  :disabled="(!vm.s_selectedFile || vm.isDisabled) && vm.isDisabled2"
                  block
                  color="primary"
                  @click="vm.savePicture"
                >
                  <v-icon start>mdi-cloud-upload</v-icon>
                  保存
                </v-btn>
              </v-col>
              <v-col cols="12" sm="6">
                <v-btn
                  :disabled="!vm.s_pictureUrl"
                  block
                  color="error"
                  variant="outlined"
                  @click="vm.deletePicture"
                >
                  <v-icon start>mdi-delete</v-icon>
                  削除
                </v-btn>
              </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" variant="text" @click="vm.s_dialogForPicture = false">
            <v-icon start>mdi-close</v-icon>
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- オフライン設定その2 -->
    <v-dialog v-model="vm.s_dialogForOffline2" max-width="500">
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-cloud-download</v-icon>
          オフライン設定その２
        </v-card-title>
        <v-card-text>
          <p style="margin-bottom: 10px;"></p>
          <v-btn @click="vm.downloadTiles">データダウンロード</v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-darken-1" text @click="vm.s_dialogForOffline2 = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- オフライン設定 -->
    <v-dialog v-model="vm.s_dialogForOffline" max-width="500">
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-cloud-off-outline</v-icon>
          オフライン設定
        </v-card-title>
        <v-card-text>
          <p style="margin-bottom: 10px;">ドロー機能と併用できません。ドロー機能を使用中の場合、閉じてください。一辺10kmの四角を移動してクリックしてください。</p>
          <v-btn @click="vm.bboxPolygon">範囲指定</v-btn>
          <v-btn style="margin-left: 10px;" @click="vm.cachesCrear">これまでのタイルをクリアする</v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-darken-1" text @click="vm.s_dialogForOffline = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- CSV列選択 -->
    <v-dialog v-model="vm.dialogForDrawCsv" max-width="560">
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-table</v-icon>
          CSV 列選択
        </v-card-title>

        <v-tabs v-model="vm.csvImportMode" color="primary" grow density="compact" class="csv-import-tabs">
          <v-tab value="geocode">
            <v-icon size="18" class="mr-1">mdi-map-marker-radius</v-icon>
            ジオコーディング
          </v-tab>
          <v-tab value="wgs84">
            <v-icon size="18" class="mr-1">mdi-earth</v-icon>
            緯度経度
          </v-tab>
          <v-tab value="jprcs">
            <v-icon size="18" class="mr-1">mdi-grid</v-icon>
            公共座標系
          </v-tab>
        </v-tabs>

        <v-card-text>
          <v-window v-model="vm.csvImportMode">
            <!-- タブ1: ジオコーディング -->
            <v-window-item value="geocode">
              <p style="margin: var(--oh3-spacing-3) 0 var(--oh3-spacing-5);">
                住所を座標に変換します。
              </p>
              <template v-if="vm.s_isAndroid">
                <div class="native-select-wrapper">
                  <label class="native-select-label" for="csv-address-select">アドレスの列を選択</label>
                  <select id="csv-address-select" v-model="vm.csvAddressColumn" class="native-select">
                    <option v-for="item in vm.csvColumns" :key="item" :value="item">{{ item }}</option>
                  </select>
                </div>
              </template>
              <v-select v-else
                        v-model="vm.csvAddressColumn"
                        :items="vm.csvColumns"
                        label="アドレスの列を選択"
                        variant="outlined"
                        density="compact"
                        :menu-props="{ maxHeight: '350px', contentClass: 'scrollable-menu' }"
              ></v-select>
            </v-window-item>

            <!-- タブ2: WGS84 緯度経度 -->
            <v-window-item value="wgs84">
              <p style="margin: var(--oh3-spacing-3) 0 var(--oh3-spacing-5);">
                CSV に含まれる緯度・経度（WGS84）をそのまま使います。
              </p>
              <template v-if="vm.s_isAndroid">
                <div class="native-select-wrapper">
                  <label class="native-select-label" for="csv-lon-select">経度の列を選択</label>
                  <select id="csv-lon-select" v-model="vm.csvLonColumn" class="native-select">
                    <option v-for="item in vm.csvColumns" :key="item" :value="item">{{ item }}</option>
                  </select>
                </div>
                <div class="native-select-wrapper">
                  <label class="native-select-label" for="csv-lat-select">緯度の列を選択</label>
                  <select id="csv-lat-select" v-model="vm.csvLatColumn" class="native-select">
                    <option v-for="item in vm.csvColumns" :key="item" :value="item">{{ item }}</option>
                  </select>
                </div>
              </template>
              <template v-else>
                <v-select v-model="vm.csvLonColumn"
                          :items="vm.csvColumns"
                          label="経度の列を選択"
                          variant="outlined"
                          density="compact"
                          :menu-props="{ maxHeight: '350px', contentClass: 'scrollable-menu' }"
                ></v-select>
                <v-select v-model="vm.csvLatColumn"
                          :items="vm.csvColumns"
                          label="緯度の列を選択"
                          variant="outlined"
                          density="compact"
                          :menu-props="{ maxHeight: '350px', contentClass: 'scrollable-menu' }"
                ></v-select>
              </template>
            </v-window-item>

            <!-- タブ3: 公共座標系（平面直角座標系） -->
            <v-window-item value="jprcs">
              <p style="margin: var(--oh3-spacing-3) 0 var(--oh3-spacing-5);">
                平面直角座標系（公共座標系）の X / Y を WGS84 に変換して取り込みます。
              </p>
              <template v-if="vm.s_isAndroid">
                <div class="native-select-wrapper">
                  <label class="native-select-label" for="csv-jprcs-zone">座標系（系番号）</label>
                  <select id="csv-jprcs-zone" v-model.number="vm.csvJprcsZone" class="native-select">
                    <option v-for="n in 19" :key="n" :value="n">{{ n }}系</option>
                  </select>
                </div>
                <div class="native-select-wrapper">
                  <label class="native-select-label" for="csv-x-select">X 列（公共座標の X / 北方向）</label>
                  <select id="csv-x-select" v-model="vm.csvXColumn" class="native-select">
                    <option v-for="item in vm.csvColumns" :key="item" :value="item">{{ item }}</option>
                  </select>
                </div>
                <div class="native-select-wrapper">
                  <label class="native-select-label" for="csv-y-select">Y 列（公共座標の Y / 東方向）</label>
                  <select id="csv-y-select" v-model="vm.csvYColumn" class="native-select">
                    <option v-for="item in vm.csvColumns" :key="item" :value="item">{{ item }}</option>
                  </select>
                </div>
              </template>
              <template v-else>
                <v-select v-model.number="vm.csvJprcsZone"
                          :items="Array.from({length: 19}, (_, i) => ({ title: (i+1) + '系', value: i+1 }))"
                          label="座標系（系番号）"
                          variant="outlined"
                          density="compact"
                          :menu-props="{ maxHeight: '350px', contentClass: 'scrollable-menu' }"
                ></v-select>
                <v-select v-model="vm.csvXColumn"
                          :items="vm.csvColumns"
                          label="X 列（公共座標の X / 北方向）"
                          variant="outlined"
                          density="compact"
                          :menu-props="{ maxHeight: '350px', contentClass: 'scrollable-menu' }"
                ></v-select>
                <v-select v-model="vm.csvYColumn"
                          :items="vm.csvColumns"
                          label="Y 列（公共座標の Y / 東方向）"
                          variant="outlined"
                          density="compact"
                          :menu-props="{ maxHeight: '350px', contentClass: 'scrollable-menu' }"
                ></v-select>
              </template>
            </v-window-item>
          </v-window>

          <!-- 共通項目 -->
          <v-divider style="margin: var(--oh3-spacing-3) 0 var(--oh3-spacing-4);"></v-divider>

          <template v-if="vm.s_isAndroid">
            <div class="native-select-wrapper">
              <label class="native-select-label" for="csv-label-select">ラベルに表示する列を選択（必須）</label>
              <select id="csv-label-select" v-model="vm.csvLabelColumn" class="native-select">
                <option v-for="item in vm.csvColumns" :key="item" :value="item">{{ item }}</option>
              </select>
            </div>
          </template>
          <v-select v-else
                    v-model="vm.csvLabelColumn"
                    :items="vm.csvColumns"
                    label="ラベルに表示する列を選択（必須）"
                    variant="outlined"
                    density="compact"
                    :menu-props="{ maxHeight: '350px', contentClass: 'scrollable-menu' }"
          ></v-select>

          <template v-if="vm.s_isAndroid">
            <div class="native-select-wrapper">
              <label class="native-select-label" for="csv-color-select">アイコンの色の列を選択（あれば）</label>
              <select id="csv-color-select" v-model="vm.csvColorColumn" class="native-select">
                <option v-for="item in vm.csvColumns" :key="item" :value="item">{{ item }}</option>
              </select>
            </div>
          </template>
          <v-select v-else
                    v-model="vm.csvColorColumn"
                    :items="vm.csvColumns"
                    label="アイコンの色の列を選択（あれば）"
                    variant="outlined"
                    density="compact"
                    :menu-props="{ maxHeight: '350px', contentClass: 'scrollable-menu' }"
          ></v-select>

          <template v-if="vm.s_isAndroid">
            <div class="native-select-wrapper">
              <label class="native-select-label" for="csv-longtext-select">長文の列を選択（あれば）</label>
              <select id="csv-longtext-select" v-model="vm.csvLongTextColumn" class="native-select">
                <option v-for="item in vm.csvColumns" :key="item" :value="item">{{ item }}</option>
              </select>
            </div>
          </template>
          <v-select v-else
                    v-model="vm.csvLongTextColumn"
                    :items="vm.csvColumns"
                    label="長文の列を選択（あれば）"
                    variant="outlined"
                    density="compact"
                    :menu-props="{ maxHeight: '350px', contentClass: 'scrollable-menu' }"
          ></v-select>

          <template v-if="vm.s_isAndroid">
            <div class="native-select-wrapper">
              <label class="native-select-label" for="csv-picture-url-select">画像URLの列を選択（あれば）</label>
              <select id="csv-picture-url-select" v-model="vm.csvPictureUrlColumn" class="native-select">
                <option v-for="item in vm.csvColumns" :key="item" :value="item">{{ item }}</option>
              </select>
            </div>
          </template>
          <v-select v-else
                    v-model="vm.csvPictureUrlColumn"
                    :items="vm.csvColumns"
                    label="画像URLの列を選択（あれば）"
                    variant="outlined"
                    density="compact"
                    :menu-props="{ maxHeight: '350px', contentClass: 'scrollable-menu' }"
          ></v-select>

          <v-btn color="success" size="large" variant="elevated" style="margin-left: 0px;" @click="vm.uploadDrawCsv">
            <span v-if="vm.csvImportMode === 'geocode'">ジオコーディング＆</span>ドロー追加
          </v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-darken-1" text @click="vm.dialogForDrawCsv = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- GeoJSON取り込み設定 -->
    <v-dialog v-model="vm.dialogForDrawGeojson" max-width="500">
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-code-json</v-icon>
          GeoJSON 取り込み設定
        </v-card-title>
        <v-card-text>
          <p style="margin-bottom: var(--oh3-spacing-5);">ポイントの色とラベル表示する属性を選択してください。</p>

          <template v-if="vm.s_isAndroid">
            <div class="native-select-wrapper">
              <label class="native-select-label" for="geojson-label-select">ラベルに表示する属性を選択（必須）</label>
              <select id="geojson-label-select" v-model="vm.geojsonLabelProperty" class="native-select">
                <option value="">(なし)</option>
                <option v-for="item in vm.geojsonProperties" :key="item" :value="item">
                  {{ item }}
                </option>
              </select>
            </div>
          </template>
          <v-select v-else
                    v-model="vm.geojsonLabelProperty"
                    :items="['(なし)', ...vm.geojsonProperties]"
                    label="ラベルに表示する属性を選択（必須）"
                    variant="outlined"
                    :menu-props="{
                      maxHeight: '350px',
                      overflow: 'scroll',
                      contentClass: 'scrollable-menu'
                    }"
          ></v-select>

          <template v-if="vm.s_isAndroid">
            <div class="native-select-wrapper">
              <label class="native-select-label" for="geojson-color-select">ポイントの色を選択</label>
              <select id="geojson-color-select" v-model="vm.geojsonPointColor" class="native-select">
                <option value="red">赤</option>
                <option value="black">黒</option>
                <option value="blue">青</option>
                <option value="green">緑</option>
                <option value="orange">オレンジ</option>
                <option value="hotpink">ホットピンク</option>
                <option value="rgba(0,0,0,0)">透明</option>
              </select>
            </div>
          </template>
          <v-select v-else
                    v-model="vm.geojsonPointColor"
                    :items="vm.colorItems"
                    item-title="label"
                    item-value="value"
                    label="ポイントの色を選択"
                    variant="outlined"
          ></v-select>

          <v-btn color="success" size="large" variant="elevated" style="margin-left: 0px;" @click="vm.uploadDrawGeojson">ドロー追加</v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-darken-1" text @click="vm.dialogForDrawGeojson = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 選択（KML/マイルーム） -->
    <v-dialog v-model="vm.dialogForDraw" max-width="500">
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-format-list-bulleted</v-icon>
          選択
        </v-card-title>
        <v-card-text>
          <p style="margin-bottom: var(--oh3-spacing-5);">2MB以上は「マイルームのマイレイヤーに追加」を選んでください。</p>
          <v-btn @click="vm.uploadMyroomKml">マイルームのマイレイヤーに追加</v-btn>
          <v-btn color="success" size="large" variant="elevated" style="margin-left: 10px;" @click="vm.uploadDrawKml">ドロー追加</v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-darken-1" text @click="vm.dialogForDraw = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- アップロード先選択（地番図/マイレイヤー/ドロー） -->
    <v-dialog v-model="vm.dialogForChibanzyOrDraw" max-width="500">
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-upload</v-icon>
          アップロード先を選択
        </v-card-title>
        <v-card-text>
          <p style="margin-bottom: var(--oh3-spacing-5);">選択してください。</p>
          <v-btn :disabled="!vm.userId" @click="vm.uploadChibanzu">地番図アップロード</v-btn>
          <v-btn :disabled="!vm.userId" style="margin-left: 10px;" @click="vm.dialogForLayerName = true,vm.dialogForChibanzyOrDraw = false">マイレイヤー追加</v-btn>
          <v-btn style="margin-left: 10px;" @click="vm.uploadDraw">ドロー追加</v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-darken-1" text @click="vm.dialogForChibanzyOrDraw = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- レイヤー名記入 -->
    <v-dialog v-model="vm.dialogForLayerName" max-width="500">
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-layers</v-icon>
          レイヤー名を記入
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="vm.s_gazoName" placeholder="レイヤー名" variant="outlined"></v-text-field>

          <template v-if="vm.s_isAndroid">
            <div class="native-select-wrapper">
              <label class="native-select-label" for="pmtiles-maximum-select">最大ズームを選択。注！原則17です。</label>
              <select id="pmtiles-maximum-select" v-model="vm.s_pmtilesMaximum" class="native-select">
                <option v-for="item in [16,17,18,19,20,21,22,23,24]" :key="item" :value="item">
                  {{ item }}
                </option>
              </select>
            </div>
          </template>
          <v-select v-else
                    v-model="vm.s_pmtilesMaximum"
                    :items="[16,17,18,19,20,21,22,23,24]"
                    label="最大ズームを選択。注！原則17です。"
                    variant="outlined"
                    :menu-props="{
                      maxHeight: '350px',
                      overflow: 'scroll',
                      contentClass: 'scrollable-menu'
                    }"
          ></v-select>

          <v-btn style="margin-left: 0px;" @click="vm.uploadMyLayer">追加</v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-darken-1" text @click="vm.dialogForLayerName = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ダウンロード -->
    <v-dialog v-model="vm.dialogForDl" max-width="500">
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-download</v-icon>
          ダウンロード
        </v-card-title>
        <v-card-text class="pt-2">
          <div class="d-flex flex-wrap ga-2">
            <v-btn color="primary" @click="vm.saveSima">SIMA</v-btn>
            <v-btn color="primary" @click="vm.saveGpx">GPX</v-btn>
            <v-btn color="primary" @click="vm.saveKml">KML</v-btn>
            <v-btn color="primary" @click="vm.saveGeojson">GeoJSON</v-btn>
            <v-btn color="primary" @click="vm.dialogForSaveDXFOpen">DXF</v-btn>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="vm.dialogForDl = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- アップロード（タイル） -->
    <v-dialog
        v-model="vm.showTileDialog"
        max-width="500"
        persistent
    >
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-cloud-upload</v-icon>
          アップロード
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="vm.s_gazoName" placeholder="名称" variant="outlined"></v-text-field>
          <v-btn @click="vm.startTiling">アップロード</v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="vm.showTileDialog = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ポップアップダイアログ -->
    <v-dialog attach="#map01" v-model="vm.s_popupDialog" max-width="500" persistent>
      <v-card>
        <div class="dialog-close" @click="vm.popupDialogClose">×</div>
        <v-card-text style="display: flex; justify-content: center; align-items: flex-start;">
          <!-- ここに既存のhtml文字列を表示 -->
          <div v-html="vm.s_popupHtml"></div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="vm.popupDialogClose">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 各種出力（SIMA/CSV/標高図） -->
    <v-dialog v-model="vm.s_pointSima" max-width="500">
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-export</v-icon>
          各種出力
        </v-card-title>
        <v-card-text style="margin-bottom: -5px;padding-bottom: 0">
          <v-text-field
              v-model="vm.segments"
              type="number"
              label="区切り数を入力"
              variant="outlined"
              :min="0"
              :max="500"
              :step="1"
          />
          <v-btn @click="vm.pointSimaCreate">SIMA作成</v-btn>
          <v-btn style="margin-left: 10px" @click="vm.pointCsvCreate">CSV作成</v-btn>
          <v-btn style="margin-left: 10px" @click="vm.elevationCreate">標高図作成</v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="vm.s_pointSima = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DXF作成 -->
    <v-dialog v-model="vm.dialogForSaveDXF2" max-width="500">
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-file-cad</v-icon>
          DXF作成
        </v-card-title>
        <v-card-text>
          <template v-if="vm.s_isAndroid">
            <div class="native-select-wrapper">
              <label class="native-select-label" for="dxf-zahyokei-select">座標系を選択</label>
              <select id="dxf-zahyokei-select" v-model="vm.s_zahyokei" class="native-select">
                <option value="" disabled>座標を選択してください</option>
                <option v-for="number in 19" :key="number" :value="`公共座標${number}系`">
                  公共座標{{ number }}系
                </option>
              </select>
            </div>
          </template>
          <v-select v-else
                    class="scrollable-content"
                    v-model="vm.s_zahyokei"
                    :items="vm.items"
                    label="座標系を選択してください"
                    variant="outlined"
                    :menu-props="{
                      maxHeight: '350px',
                      overflow: 'scroll',
                      contentClass: 'scrollable-menu'
                    }"
          ></v-select>
          <v-btn @click="vm.saveDxf">DXF出力開始</v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-darken-1" text @click="vm.dialogForSaveDXF2 = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DXF出力設定 -->
    <v-dialog v-model="vm.dialogForVisibleDXF" max-width="500">
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-file-cad</v-icon>
          DXF出力設定
        </v-card-title>
        <v-card-text>
          <div class="oh3-mb-4">
            <div class="oh3-font-bold oh3-mb-2">CADタイプ</div>
            <template v-if="vm.s_isAndroid">
              <div class="native-select-wrapper">
                <select v-model="vm.visibleDxfCadType" class="native-select">
                  <option v-for="item in vm.visibleDxfCadTypeItems" :key="item.value" :value="item.value">
                    {{ item.text }}
                  </option>
                </select>
              </div>
            </template>
            <v-select v-else
                      v-model="vm.visibleDxfCadType"
                      :items="vm.visibleDxfCadTypeItems"
                      item-title="text"
                      item-value="value"
                      variant="outlined"
                      density="compact"
            ></v-select>
          </div>
          <div class="oh3-mb-4">
            <div class="oh3-font-bold oh3-mb-2">座標系</div>
            <template v-if="vm.s_isAndroid">
              <div class="native-select-wrapper">
                <select v-model="vm.s_zahyokei" class="native-select">
                  <option value="" disabled>座標を選択してください</option>
                  <option v-for="number in 19" :key="number" :value="`公共座標${number}系`">
                    公共座標{{ number }}系
                  </option>
                </select>
              </div>
            </template>
            <v-select v-else
                      v-model="vm.s_zahyokei"
                      :items="vm.items"
                      label="座標系を選択してください"
                      variant="outlined"
                      density="compact"
                      :menu-props="{
                        maxHeight: '350px',
                        overflow: 'scroll',
                        contentClass: 'scrollable-menu'
                      }"
            ></v-select>
          </div>
          <v-btn color="primary" @click="vm.execVisibleDxfExport">DXF出力開始</v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn variant="text" @click="vm.dialogForVisibleDXF = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 求積表からSIMA作成 -->
    <v-dialog v-model="vm.dialogForImagePng" max-width="500">
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-file-document-outline</v-icon>
          求積表からSIMA作成
        </v-card-title>
        <v-card-text>
          <template v-if="vm.s_isAndroid">
            <div class="native-select-wrapper">
              <label class="native-select-label" for="sima-zahyokei-select">座標系を選択</label>
              <select id="sima-zahyokei-select" v-model="vm.s_zahyokei" class="native-select">
                <option value="" disabled>座標を選択してください</option>
                <option v-for="number in 19" :key="number" :value="`公共座標${number}系`">
                  公共座標{{ number }}系
                </option>
              </select>
            </div>
          </template>
          <v-select v-else
                    class="scrollable-content"
                    v-model="vm.s_zahyokei"
                    :items="vm.items"
                    label="座標系を選択してください"
                    variant="outlined"
                    :menu-props="{
                      maxHeight: '350px',
                      overflow: 'scroll',
                      contentClass: 'scrollable-menu'
                    }"
          ></v-select>
          <v-btn @click="vm.imagePngLoad">png読込開始</v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-darken-1" text @click="vm.dialogForImagePng = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 地番図アップロード -->
    <v-dialog v-model="vm.s_showChibanzuDialog" max-width="500">
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-map</v-icon>
          地番図アップロード
        </v-card-title>
        <v-card-text>
          <template v-if="vm.s_isAndroid">
            <v-text-field v-model="vm.s_pmtilesName" type="email" placeholder="地番図名" variant="outlined"></v-text-field>
            <div class="native-select-wrapper">
              <label class="native-select-label" for="chibanzu-field-select">地番にあたるフィールドを選択</label>
              <select id="chibanzu-field-select" v-model="vm.s_pmtilesPropertieName" class="native-select">
                <option v-for="item in vm.s_chibanzuPropaties" :key="item" :value="item">
                  {{ item }}
                </option>
              </select>
            </div>
            <div class="native-select-wrapper">
              <label class="native-select-label" for="chibanzu-pref-select">都道府県名を選択</label>
              <select id="chibanzu-pref-select" v-model="vm.s_chibanzuPrefCode" class="native-select">
                <option v-for="item in vm.prefItems" :key="item.prefCode" :value="item.prefCode">
                  {{ item.prefName }}
                </option>
              </select>
            </div>
            <div class="native-select-wrapper">
              <label class="native-select-label" for="chibanzu-city-select">市区町村名を選択</label>
              <select id="chibanzu-city-select" v-model="vm.s_chibanzuCityCode" class="native-select">
                <option v-for="item in vm.cityItems" :key="item.cityCode" :value="item.cityCode">
                  {{ item.cityName }}
                </option>
              </select>
            </div>
            <div class="native-select-wrapper">
              <label class="native-select-label" for="chibanzu-public-select">公開方法を選択</label>
              <select id="chibanzu-public-select" v-model="vm.s_selectedPublic" class="native-select">
                <option v-for="item in vm.publicItems" :key="item.public" :value="item.public">
                  {{ item.label }}
                </option>
              </select>
            </div>
            <div class="native-select-wrapper">
              <label class="native-select-label" for="chibanzu-kaiji2-select">２次開示確認</label>
              <select id="chibanzu-kaiji2-select" v-model="vm.s_selectedKaiji2" class="native-select">
                <option v-for="item in vm.kaiji2s" :key="item.kaiji2" :value="item.kaiji2">
                  {{ item.label }}
                </option>
              </select>
            </div>
          </template>
          <template v-else>
            <v-text-field v-model="vm.s_pmtilesName" type="email" placeholder="地番図名" variant="outlined"></v-text-field>
            <v-select class="scrollable-content"
                      v-model="vm.s_pmtilesPropertieName"
                      :items="vm.s_chibanzuPropaties"
                      label="地番にあたるフィールドを選択してください"
                      variant="outlined"
            ></v-select>
            <v-select
                v-model="vm.s_chibanzuPrefCode"
                :items="vm.prefItems"
                item-title="prefName"
                item-value="prefCode"
                label="都道府県名を選択してください"
                variant="outlined"
            ></v-select>
            <v-select
                v-model="vm.s_chibanzuCityCode"
                :items="vm.cityItems"
                item-title="cityName"
                item-value="cityCode"
                label="市区町村名を選択してください"
                variant="outlined"
            ></v-select>
            <v-select
                v-model="vm.s_selectedPublic"
                :items="vm.publicItems"
                item-title="label"
                item-value="public"
                label="公開方法を選択してください"
                variant="outlined"
            ></v-select>
            <v-select
                v-model="vm.s_selectedKaiji2"
                :items="vm.kaiji2s"
                item-title="label"
                item-value="kaiji2"
                label="２次開示確認"
                variant="outlined"
            ></v-select>
          </template>
          <v-btn @click="vm.shpLoad">読込開始</v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-darken-1" text @click="vm.s_showChibanzuDialog = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DXF読込 座標系選択 -->
    <v-dialog v-model="vm.dialogForDxfApp" max-width="500">
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-tune</v-icon>
          座標系選択
        </v-card-title>
        <v-card-text>
          <template v-if="vm.s_isAndroid">
            <div class="native-select-wrapper">
              <label class="native-select-label" for="dxf-load-zahyokei-select">座標系を選択</label>
              <select id="dxf-load-zahyokei-select" v-model="vm.s_zahyokei" class="native-select">
                <option value="" disabled>座標を選択してください</option>
                <option v-for="number in 19" :key="number" :value="`公共座標${number}系`">
                  公共座標{{ number }}系
                </option>
              </select>
            </div>
          </template>
          <v-select v-else
                    class="scrollable-content"
                    v-model="vm.s_zahyokei"
                    :items="vm.items"
                    label="選択してください"
                    variant="outlined"
                    :menu-props="{
                      maxHeight: '350px',
                      overflow: 'scroll',
                      contentClass: 'scrollable-menu'
                    }"
          ></v-select>
          <v-btn @click="vm.dxfLoad">DXF読込開始</v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-darken-1" text @click="vm.dialogForDxfApp = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- PNGダウンロード 座標系選択 -->
    <v-dialog v-model="vm.s_dialogForPngApp" max-width="500">
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-tune</v-icon>
          座標系選択
        </v-card-title>
        <v-card-text>
          <template v-if="vm.s_isAndroid">
            <div class="native-select-wrapper">
              <label class="native-select-label" for="png-download-zahyokei-select">座標系を選択</label>
              <select id="png-download-zahyokei-select" v-model="vm.s_zahyokei" class="native-select">
                <option value="" disabled>座標を選択してください</option>
                <option v-for="number in 19" :key="number" :value="`公共座標${number}系`">
                  公共座標{{ number }}系
                </option>
              </select>
            </div>
          </template>
          <v-select v-else
                    class="scrollable-content"
                    v-model="vm.s_zahyokei"
                    :items="vm.items"
                    label="選択してください"
                    variant="outlined"
                    :menu-props="{
                      maxHeight: '350px',
                      overflow: 'scroll',
                      contentClass: 'scrollable-menu'
                    }"
          ></v-select>
          <v-btn @click="vm.pngDownload">PNGダウンロード開始</v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-darken-1" text @click="vm.s_dialogForPngApp = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- PDF読込 -->
    <v-dialog v-model="vm.dialogForPdfApp" max-width="500">
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-file-pdf-box</v-icon>
          登記情報提供サービスより取得した公図PDF
        </v-card-title>
        <v-card-text>
          <template v-if="vm.s_isAndroid">
            <div class="native-select-wrapper">
              <label class="native-select-label" for="pdf-zahyokei-select">座標系を選択</label>
              <select id="pdf-zahyokei-select" v-model="vm.s_zahyokei" class="native-select">
                <option value="" disabled>座標を選択してください</option>
                <option v-for="number in 19" :key="number" :value="`公共座標${number}系`">
                  公共座標{{ number }}系
                </option>
              </select>
            </div>
            <template v-if="vm.userId">
              <div v-if="vm.s_isAndroid" class="native-select-wrapper">
                <label class="native-select-label" for="pdf-resolution-select">画像取込最大解像度</label>
                <select id="pdf-resolution-select" v-model="vm.s_resolution" class="native-select">
                  <option v-for="item in vm.resolutions" :key="item" :value="item">
                    {{ item }}
                  </option>
                </select>
              </div>
              <v-select v-else
                        class="scrollable-content"
                        v-model="vm.s_resolution"
                        :items="vm.resolutions"
                        label="画像取込最大解像度"
                        variant="outlined"
                        :menu-props="{
                          maxHeight: '350px',
                          overflow: 'scroll',
                          contentClass: 'scrollable-menu'
                        }"
              ></v-select>
            </template>
            <v-switch style="height: 40px;margin-bottom: var(--oh3-spacing-5);" v-model="vm.s_isTransparent" label="透過処理" color="primary" />
          </template>
          <v-btn @click="vm.pdfLoad">PDF読込開始</v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-darken-1" text @click="vm.dialogForPdfApp = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- PDF出力オプション -->
    <v-dialog v-model="vm.dialogForPdfPrintOptions" max-width="460">
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-file-pdf-box</v-icon>
          PDF出力
        </v-card-title>
        <v-card-text>
          <v-switch
              class="draw-config-switch"
              v-model="vm.printTileEnabledLocal"
              label="A0相当を分割印刷"
              color="primary"
              hide-details
          />
          <div class="print-tile-note">
            A0相当の範囲を選択した用紙サイズで分割してPDFに出力します。
          </div>
          <div class="print-tile-note">
            通常はそのままPDF出力をクリックしてください。
          </div>
          <v-select
              v-if="vm.printTileEnabledLocal"
              v-model="vm.printTileSizeLocal"
              :items="vm.printTileSizeItems"
              item-title="label"
              item-value="value"
              label="分割用紙サイズ"
              variant="outlined"
              density="compact"
              hide-details
              class="draw-config-compact-select oh3-mt-2"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-darken-1" text @click="vm.dialogForPdfPrintOptions = false">閉じる</v-btn>
          <v-btn color="success" @click="vm.confirmPdfDl">PDF出力</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 画像取込最大解像度選択（geotiff 1file） -->
    <v-dialog v-model="vm.dialogForGeotiffApp1file" max-width="500">
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-image-size-select-large</v-icon>
          画像取込最大解像度選択
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="vm.s_gazoName" placeholder="名称" variant="outlined"></v-text-field>
          <template v-if="vm.s_isAndroid">
            <div class="native-select-wrapper">
              <label class="native-select-label" for="geotiff1-zahyokei-select">座標系を選択</label>
              <select id="geotiff1-zahyokei-select" v-model="vm.s_zahyokei" class="native-select">
                <option value="" disabled>座標を選択してください</option>
                <option v-for="number in 19" :key="number" :value="`公共座標${number}系`">
                  公共座標{{ number }}系
                </option>
              </select>
            </div>
          </template>
          <v-select v-else
                    class="scrollable-content"
                    v-model="vm.s_zahyokei"
                    :items="vm.items"
                    label="座標系を選択"
                    variant="outlined"
                    :menu-props="{
                      maxHeight: '350px',
                      overflow: 'scroll',
                      contentClass: 'scrollable-menu'
                    }"
          ></v-select>
          <template v-if="vm.userId">
            <template v-if="vm.s_isAndroid">
              <div class="native-select-wrapper">
                <label class="native-select-label" for="geotiff1-resolution-select">画像取込最大解像度</label>
                <select id="geotiff1-resolution-select" v-model="vm.s_resolution" class="native-select">
                  <option v-for="item in vm.resolutions" :key="item" :value="item">
                    {{ item }}
                  </option>
                </select>
              </div>
            </template>
            <v-select v-else
                      class="scrollable-content"
                      v-model="vm.s_resolution"
                      :items="vm.resolutions"
                      label="画像取込最大解像度"
                      variant="outlined"
                      :menu-props="{
                        maxHeight: '350px',
                        overflow: 'scroll',
                        contentClass: 'scrollable-menu'
                      }"
            ></v-select>
          </template>
          <v-btn color="success" size="large" variant="elevated" @click="vm.geoTifLoad1file">geotif読込開始</v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-darken-1" text @click="vm.dialogForGeotiffApp1file = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 画像アップロード（geotiff） -->
    <v-dialog v-model="vm.s_dialogForGeotiffApp" max-width="500">
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-cloud-upload</v-icon>
          画像アップロード
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="vm.s_gazoName" placeholder="名称" variant="outlined"></v-text-field>
          <template v-if="vm.s_isAndroid">
            <div class="native-select-wrapper">
              <label class="native-select-label" for="geotiff-zahyokei-select">座標系を選択</label>
              <select id="geotiff-zahyokei-select" v-model="vm.s_zahyokei" class="native-select">
                <option value="" disabled>座標を選択してください</option>
                <option v-for="number in 19" :key="number" :value="`公共座標${number}系`">
                  公共座標{{ number }}系
                </option>
              </select>
            </div>
          </template>
          <v-select v-else
                    class="scrollable-content"
                    v-model="vm.s_zahyokei"
                    :items="vm.items"
                    label="座標系を選択"
                    variant="outlined"
                    :menu-props="{
                      maxHeight: '350px',
                      overflow: 'scroll',
                      contentClass: 'scrollable-menu'
                    }"
          ></v-select>
          <template v-if="vm.userId">
            <template v-if="vm.s_isAndroid">
              <div class="native-select-wrapper">
                <label class="native-select-label" for="geotiff-transparent-select">透過方法を選択</label>
                <select id="geotiff-transparent-select" v-model="vm.s_transparent" class="native-select">
                  <option v-for="item in vm.transparentType" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </option>
                </select>
              </div>
            </template>
            <v-select v-else
                      class="scrollable-content"
                      v-model="vm.s_transparent"
                      :items="vm.transparentType"
                      item-title="label"
                      item-value="value"
                      label="透過方法を選択してください"
                      variant="outlined"
                      :menu-props="{
                        maxHeight: '350px',
                        overflow: 'scroll',
                        contentClass: 'scrollable-menu'
                      }"
            ></v-select>
          </template>
          <v-btn color="success" size="large" variant="elevated" @click="vm.geoTiffLoad0">geotiff読込開始！</v-btn>
          <div class="oh3-token-cost" style="text-align: left; font-size: var(--oh3-font-size-xs); color: var(--oh3-color-text-secondary); margin-top: 4px;">
            <v-icon size="12" class="mr-1">mdi-circle-multiple-outline</v-icon>
            1回 15トークン
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-darken-1" text @click="vm.s_dialogForGeotiffApp = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 画像アップロード（geotiff2） -->
    <v-dialog v-model="vm.s_dialogForGeotiff2App" max-width="500">
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-cloud-upload</v-icon>
          画像アップロード
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="vm.s_gazoName" placeholder="名称" variant="outlined"></v-text-field>
          <template v-if="vm.s_isAndroid">
            <div class="native-select-wrapper">
              <label class="native-select-label" for="geotiff2-zahyokei-select">座標系を選択</label>
              <select id="geotiff2-zahyokei-select" v-model="vm.s_zahyokei" class="native-select">
                <option value="" disabled>座標を選択してください</option>
                <option v-for="item in vm.items" :key="item" :value="item">
                  {{ item }}
                </option>
              </select>
            </div>
          </template>
          <v-select v-else
                    class="scrollable-content"
                    v-model="vm.s_zahyokei"
                    :items="vm.items"
                    label="座標系を選択"
                    variant="outlined"
                    :menu-props="{
                      maxHeight: '350px',
                      overflow: 'scroll',
                      contentClass: 'scrollable-menu'
                    }"
          ></v-select>
          <template v-if="vm.userId">
            <template v-if="vm.s_isAndroid">
              <div class="native-select-wrapper">
                <label class="native-select-label" for="geotiff2-transparent-select">透過方法を選択</label>
                <select id="geotiff2-transparent-select" v-model="vm.s_transparent" class="native-select">
                  <option v-for="item in vm.transparentType" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </option>
                </select>
              </div>
            </template>
            <v-select v-else
                      class="scrollable-content"
                      v-model="vm.s_transparent"
                      :items="vm.transparentType"
                      item-title="label"
                      item-value="value"
                      label="透過方法を選択してください"
                      variant="outlined"
                      :menu-props="{
                        maxHeight: '350px',
                        overflow: 'scroll',
                        contentClass: 'scrollable-menu'
                      }"
            ></v-select>
          </template>
          <v-btn color="success" size="large" variant="elevated" @click="vm.geoTifLoad1file">geotiff読込開始</v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-darken-1" text @click="vm.s_dialogForGeotiff2App = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 画像アップロード（JPG） -->
    <v-dialog v-model="vm.s_dialogForJpgApp" max-width="500">
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-cloud-upload</v-icon>
          画像アップロード
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="vm.s_gazoName" placeholder="名称" variant="outlined"></v-text-field>
          <template v-if="vm.s_isAndroid">
            <div class="native-select-wrapper">
              <label class="native-select-label" for="jpg-zahyokei-select">座標系を選択</label>
              <select id="jpg-zahyokei-select" v-model="vm.s_zahyokei" class="native-select">
                <option value="" disabled>座標を選択してください</option>
                <option v-for="item in vm.items" :key="item" :value="item">
                  {{ item }}
                </option>
              </select>
            </div>
          </template>
          <v-select v-else
                    class="scrollable-content"
                    v-model="vm.s_zahyokei"
                    :items="vm.items"
                    label="座標系を選択"
                    variant="outlined"
                    :menu-props="{
                      maxHeight: '350px',
                      overflow: 'scroll',
                      contentClass: 'scrollable-menu'
                    }"
          ></v-select>
          <template v-if="vm.userId">
            <template v-if="vm.s_isAndroid">
              <div class="native-select-wrapper">
                <label class="native-select-label" for="jpg-transparent-select">透過方法を選択</label>
                <select id="jpg-transparent-select" v-model="vm.s_transparent" class="native-select">
                  <option v-for="item in vm.transparentType" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </option>
                </select>
              </div>
            </template>
            <v-select v-else
                      class="scrollable-content"
                      v-model="vm.s_transparent"
                      :items="vm.transparentType"
                      item-title="label"
                      item-value="value"
                      label="透過方法を選択してください"
                      variant="outlined"
                      :menu-props="{
                        maxHeight: '350px',
                        overflow: 'scroll',
                        contentClass: 'scrollable-menu'
                      }"
            ></v-select>
          </template>
          <v-btn color="success" size="large" variant="elevated" @click="vm.jpgLoad0">jpg読込開始</v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-darken-1" text @click="vm.s_dialogForJpgApp = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 画像アップロード（PNG） -->
    <v-dialog v-model="vm.s_dialogForPng2App" max-width="500">
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-cloud-upload</v-icon>
          画像アップロード
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="vm.s_gazoName" placeholder="名称" variant="outlined"></v-text-field>
          <template v-if="vm.s_isAndroid">
            <div class="native-select-wrapper">
              <label class="native-select-label" for="png2-zahyokei-select">座標系を選択</label>
              <select id="png2-zahyokei-select" v-model="vm.s_zahyokei" class="native-select">
                <option value="" disabled>座標を選択してください</option>
                <option v-for="item in vm.items" :key="item" :value="item">
                  {{ item }}
                </option>
              </select>
            </div>
          </template>
          <v-select v-else
                    class="scrollable-content"
                    v-model="vm.s_zahyokei"
                    :items="vm.items"
                    label="座標系を選択"
                    variant="outlined"
                    :menu-props="{
                      maxHeight: '350px',
                      overflow: 'scroll',
                      contentClass: 'scrollable-menu'
                    }"
          ></v-select>
          <template v-if="vm.userId">
            <template v-if="vm.s_isAndroid">
              <div class="native-select-wrapper">
                <label class="native-select-label" for="png2-transparent-select">透過方法を選択</label>
                <select id="png2-transparent-select" v-model="vm.s_transparent" class="native-select">
                  <option v-for="item in vm.transparentType" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </option>
                </select>
              </div>
            </template>
            <v-select v-else
                      class="scrollable-content"
                      v-model="vm.s_transparent"
                      :items="vm.transparentType"
                      item-title="label"
                      item-value="value"
                      label="透過方法を選択してください"
                      variant="outlined"
                      :menu-props="{
                        maxHeight: '350px',
                        overflow: 'scroll',
                        contentClass: 'scrollable-menu'
                      }"
            ></v-select>
          </template>
          <v-btn color="success" size="large" variant="elevated" @click="vm.pngLoad0">png読込開始</v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-darken-1" text @click="vm.s_dialogForPng2App = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- SIMA読込 座標系選択 -->
    <v-dialog v-model="vm.s_dialogForSimaApp" max-width="500">
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-tune</v-icon>
          座標系選択
        </v-card-title>
        <v-card-text>
          <template v-if="vm.s_isAndroid">
            <div class="native-select-wrapper">
              <label class="native-select-label" for="sima-zahyokei-select">座標系を選択</label>
              <select id="sima-zahyokei-select" v-model="vm.s_zahyokei" class="native-select">
                <option value="" disabled>座標を選択してください</option>
                <option v-for="number in 19" :key="number" :value="`公共座標${number}系`">
                  公共座標{{ number }}系
                </option>
              </select>
            </div>
          </template>
          <v-select v-else
                    class="scrollable-content"
                    v-model="vm.s_zahyokei"
                    :items="vm.items"
                    label="選択してください"
                    variant="outlined"
                    :menu-props="{
                      maxHeight: '350px',
                      overflow: 'scroll',
                      contentClass: 'scrollable-menu'
                    }"
          ></v-select>
          <v-btn color="success" size="large" variant="elevated" @click="vm.loadSima">SIMA読込開始</v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-darken-1" text @click="vm.s_dialogForSimaApp = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 利用規約 -->
    <v-dialog v-model="vm.dialog" max-width="500">
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-file-document-outline</v-icon>
          open-hinata3 利用規約
        </v-card-title>
        <v-card-text>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-darken-1" text @click="vm.dialog = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialogForPdfPrintOptions は v-main 内にあるが、DialogContainer に移動 -->

  </div>
</template>

<script>
/* eslint-disable vue/no-mutating-props */
/**
 * DialogContainer.vue
 *
 * App.vue のテンプレートから v-dialog ブロックを切り出したコンテナ。
 * App.vue の vm（this）を prop として受け取り、
 * すべてのデータ・メソッドに vm.xxx でアクセスする。
 *
 * vm は App.vue の this そのものなので、mutation は意図的。
 * （vue/no-mutating-props を無効化）
 */
import MiniTooltip from '@/components/MiniTooltip.vue'

export default {
  name: 'DialogContainer',
  components: {
    MiniTooltip,
  },
  props: {
    vm: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>
/* v-card が flex column のため v-tabs が 0 に潰れるのを防ぐ */
.csv-import-tabs {
  flex: none;
}
</style>
